import type { MultilinkStoryblok } from "~/generated/sb/blok-types";

const formatUrlLink = (link: MultilinkStoryblok) => {
	if ("url" in link)
		return link.url?.startsWith("/") || link.url?.startsWith("http") ? link.url : `/${link.url}`;
	throw new Error("Link is not an asset or url link");
};

const checkIfInfoPage = (link: string) => {
	const infoPagesRegex = /\/info-pages(\/.+)$/i;
	const isInfoPage = link.match(infoPagesRegex);
	const url = isInfoPage?.[1] ? `/${isInfoPage[1]}` : null;

	return url;
};

const checkIfHome = (link: string) => {
	const homeRegex = /\/?home\/?/i;
	const isHome = link.match(homeRegex);
	const url = isHome?.[0] ? "/" : null;

	return url;
};
const getStoryUrl = (link: MultilinkStoryblok) => {
	if ("story" in link) return link.story?.full_slug || "";
	if (link.linktype === "story") return link.cached_url || "";
	throw new Error("Link is not a story link");
};

const formatStoryLink = (link: MultilinkStoryblok) => {
	const url = getStoryUrl(link);
	if (checkIfInfoPage(url)) return checkIfInfoPage(url) as string;
	if (checkIfHome(url)) return checkIfHome(url) as string;
	return `/${url}`;
};

export const getLink = (link: MultilinkStoryblok) => {
	if (!link) return null;
	if (link.linktype === "url" || link.linktype === "asset") {
		return formatUrlLink(link);
	}
	if (link.linktype === "story") {
		return formatStoryLink(link);
	}

	return "";
};
